<div class="forwarding-settings">
  <header class="forwarding-settings__header">
    <h2>{{ 'settings.forwarding.title' | translate }}</h2>
    <p>{{ 'settings.forwarding.subtitle' | translate }}</p>
  </header>

  <p-card styleClass="security-settings__card">
    <div class="simple-form">
      <div class="field-row">
        <label for="forward-calls">{{ 'settings.forwarding.enableLabel' | translate }}</label>
        <p-checkbox id="forward-calls" binary="true" [(ngModel)]="isForwardEnabled"></p-checkbox>
      </div>
      <div class="field-row">
        <label for="forward-to">{{ 'settings.forwarding.forwardToLabel' | translate }}</label>
        <input type="text" id="forward-to" pInputText [placeholder]="'settings.forwarding.forwardToPlaceholder' | translate"/>
      </div>
      <div class="field-row">
        <label for="ring-timeout">{{ 'settings.forwarding.ringTimeoutLabel' | translate }}</label>
        <input type="number" id="ring-timeout" pInputText [placeholder]="'settings.forwarding.ringTimeoutPlaceholder' | translate"/>
      </div>
    </div>

    <div class="form-actions">
      <button pButton [label]="'settings.forwarding.updateButton' | translate" class="p-button-success"></button>
      <button pButton [label]="'settings.forwarding.cancelButton' | translate" class="p-button-secondary"></button>
    </div>
  </p-card>
</div>
